<template>
    <!--    政策申请-第三方服务机构-列表组件-->
    <div class="policyList">
    <ul >
            <li v-for="(item,index) in policydata" :key="index" @click="inforClick(item,index)">
                <div>
                    <p :class="item.sel?'imgHoverP':'imgP'"><span></span></p>
                </div>
                <div :class="item.sel?'policyClassify policyClassifyBack':'policyClassify'">
                    <el-image :src="item.logo" fit="cover"></el-image>
                    <div>
                        <p>{{item.mechanismName}}</p>
                        <el-button @click="lookDetail(item,index)">查看详情</el-button>
                    </div>
                </div>
            </li>
    </ul>
    </div>
    
</template>

<script>
    export default {
        name: "lp-PolicyApplyList",
        props:['policydata'],
        data(){
            return{
                radio: '0'
            }
        },
        methods:{
            inforClick(item,index){
                var dataType={
                    id:item.id,
                    index:index
                }
                this.$emit('selectID',dataType)
            },
            // 查看详情
            lookDetail(item,index){
                let routeData = this.$router.resolve({
                    path:"/serviceOrganization/"+item.id
                });
                window.open(routeData.href, '_blank');
            },
        }
    }
</script>

<style lang="less" scoped>
    .policyList{
        width: 100%;
        border: 1px solid #E1E3E4;
        border-radius: 4px;
        padding: 20px 14px;
        box-sizing: border-box;
        max-height: 720px;//最多10条，多了滚动
        overflow-y: scroll;
    }
    ul{
        width: 100%;
        li>label{
            width: 100%;
            display: flex;
            align-items: center;
        }
        li{
            cursor: pointer;
            width: 100%; 
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .imgP{
                width: 15px;
                height: 15px;
                border: 1px solid #ededed;
                border-radius: 100%;
                box-sizing: border-box;
                margin-right: 14px;
            }
           .imgHoverP{
                margin-right: 14px;
                width: 15px;
                height: 15px;
                border: 1px solid #ededed;
                border-radius: 100%;
                box-sizing: border-box;
                background: cornflowerblue;
                display: flex;
                align-items: center;
                justify-content: center;
                span{
                    background: #fff;
                    width: 5px;
                    height: 5px;
                    border-radius: 100%;
                }
            } 
            .policyClassifyBack{
               background: #F5F5F5;
            }
            .policyClassify{
                padding: 0 10px;
                width: 100%!important;
                height: 120px;
                margin: 10px 0;
                display: flex;
                align-items: center;
                position: relative;
                overflow: hidden;
                /*图片*/
                .el-image{
                    width: 100px;
                    height: 100px;
                    margin-right: 14px;
                }
                p{
                    font-family: MicrosoftYaHeiUI-Bold;
                    font-size: 16px;
                    color: #333333;
                    text-overflow:ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    width: 100%;
                }
            }
            .policyClassify>div{
                height: 90px;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: space-between;
            }
            
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/policyapplylist/index.vue